/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Subtitle_Max_Lines_LabelInputs */

const en_audio_description_export_subtitle_max_lines_label = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum Lines`)
};

const fr_audio_description_export_subtitle_max_lines_label = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre maximal de lignes`)
};

const de_audio_description_export_subtitle_max_lines_label = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Zeilenanzahl`)
};

const it_audio_description_export_subtitle_max_lines_label = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linee massime`)
};

const ru_audio_description_export_subtitle_max_lines_label = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальное количество строк`)
};

const es_audio_description_export_subtitle_max_lines_label = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo de líneas`)
};

const zh_cn2_audio_description_export_subtitle_max_lines_label = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大线路`)
};

const ja_audio_description_export_subtitle_max_lines_label = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大行数`)
};

const hi_audio_description_export_subtitle_max_lines_label = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिकतम रेखाएँ`)
};

const pt_pt2_audio_description_export_subtitle_max_lines_label = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número máximo de linhas`)
};

/**
* | output |
* | --- |
* | "Maximum Lines" |
*
* @param {Audio_Description_Export_Subtitle_Max_Lines_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_subtitle_max_lines_label = /** @type {((inputs?: Audio_Description_Export_Subtitle_Max_Lines_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Subtitle_Max_Lines_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_subtitle_max_lines_label(inputs)
	if (locale === "de") return de_audio_description_export_subtitle_max_lines_label(inputs)
	if (locale === "it") return it_audio_description_export_subtitle_max_lines_label(inputs)
	if (locale === "ru") return ru_audio_description_export_subtitle_max_lines_label(inputs)
	if (locale === "es") return es_audio_description_export_subtitle_max_lines_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_subtitle_max_lines_label(inputs)
	if (locale === "ja") return ja_audio_description_export_subtitle_max_lines_label(inputs)
	if (locale === "hi") return hi_audio_description_export_subtitle_max_lines_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_subtitle_max_lines_label(inputs)
	return en_audio_description_export_subtitle_max_lines_label(inputs)
});